import { args } from 'nest/common/args';
export const onCopilotToggled = {
  onCopilotToggled: {
    args: {
      source: args.string()
    }
  }
};